import { AUDIENCE } from "@/data/eventData";

export default function WhoWillAttend() {
  return (
    <section id="attendees" className="relative py-24 border-t border-cyan-900/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="mono text-[11px] uppercase tracking-[0.24em] text-cyan-300">
              05 · Who Will Attend
            </div>
            <h2 className="font-display mt-4 text-3xl lg:text-4xl font-bold text-white">
              A room built for decisions.
            </h2>
            <p className="mt-6 text-slate-400">
              Attendance is curated. The audience is senior — those who set
              policy, run defence operations, or protect the nation&apos;s critical
              systems.
            </p>
          </div>
          <div className="lg:col-span-8">
            <div className="flex flex-wrap gap-2">
              {AUDIENCE.map((a) => (
                <span
                  key={a}
                  className="inline-flex items-center gap-2 rounded-full border border-cyan-500/30 bg-[#0B1120] px-4 py-2 text-sm text-slate-200 hover:border-cyan-400/70 hover:text-cyan-200 transition-colors"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                  {a}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
